<template>
  <td>
    <div class="field">
      <div class="control">
        <money :class="{'input': true}" v-model="value_row.tickets" v-bind="number_format" readonly></money>
      </div>
    </div>
    <div class="field">
      <div class="control">
        <button class="button is-primary" type="button" @click="modifyTickets('edit')" alt="Edit"><i class="fa fa-edit"></i></button>
        <button class="button is-info" type="button" @click="modifyTickets('clear')" alt="Clear"><i class="fa fa-trash"></i></button>
        <button class="button is-danger" type="button" @click="addMinusTickets('-')" alt="Minus"><i class="fa fa-minus"></i></button>
        <button class="button is-success" type="button" @click="addMinusTickets('+')" alt="Plus"><i class="fa fa-plus"></i></button>
      </div>
    </div>
  </td>
</template>

<script>
import {Money} from 'v-money'
export default {
  data () {
    return {
      index_parent: '',
      index_counter_event: '',
      counter_active: 0,
      value_row: {},
      number_format: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      }
    }
  },
  created () {
    this.value_row = this.valueRow
    this.index_parent = this.indexParent
    this.counter_active = this.counterActive
    this.index_counter_event = this.indexCounterEvent
  },
  props: [
    'valueRow',
    'indexParent',
    'counterActive',
    'indexCounterEvent'
  ],
  components: {
    Money
  },
  watch: {
    valueRow (value) {
      this.value_row = value
    },
    indexParent (value) {
      this.index_parent = value
    },
    counterActive (value) {
      this.counter_active = value
    },
    indexCounterEvent (value) {
      this.index_counter_event = value
    }
  },
  methods: {
    addMinusTickets (flag) {
      if (this.counter_active === true) {
        this.$geb.emit({id: 'add-minus-tickets', flag: flag, index_parent: this.index_parent, index_counter_event: this.index_counter_event})
      }
    },
    modifyTickets (action) {
      if (this.counter_active === true) {
        this.$geb.emit({id: 'modify-tickets', action: action, index_parent: this.index_parent, index_counter_event: this.index_counter_event})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/task/components/EventServiceCounterRow.vue